import React, { Component } from 'react';

class user extends Component {
    render() {
        return (
            <div>
                
            </div>
        );
    }
}

export default user;


// WEBPACK FOOTER //
// ./src/components/setting/user.js